/**
 * WHYSHIFT variant helper drawer — scoped sidebar for variant option helpers.
 */
class WhyshiftVariantDrawer extends HTMLElement {
  /** @type {HTMLDialogElement | null} */
  #dialog = null;

  /** @type {number} */
  #previousScrollY = 0;

  connectedCallback() {
    this.#dialog = this.querySelector('dialog');
    this.querySelector('[data-whyshift-drawer-close]')?.addEventListener('click', () => this.close());
    this.#dialog?.addEventListener('click', (event) => {
      if (event.target === this.#dialog) {
        this.close();
      }
    });
    this.#dialog?.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.close();
    });
  }

  open() {
    const dialog = this.#dialog ?? this.querySelector('dialog');
    if (!dialog || dialog.open) return;

    this.#dialog = dialog;
    this.#previousScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.#previousScrollY}px`;
    document.body.style.width = '100%';

    dialog.classList.remove('whyshift-variant-drawer__dialog--closing');
    dialog.showModal();
  }

  close() {
    const dialog = this.#dialog ?? this.querySelector('dialog');
    if (!dialog || !dialog.open) return;

    const finishClose = () => {
      dialog.close();
      dialog.classList.remove('whyshift-variant-drawer__dialog--closing');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo({ top: this.#previousScrollY, behavior: 'instant' });
    };

    dialog.classList.add('whyshift-variant-drawer__dialog--closing');

    const onAnimationEnd = (event) => {
      if (event.target !== dialog) return;
      dialog.removeEventListener('animationend', onAnimationEnd);
      finishClose();
    };

    dialog.addEventListener('animationend', onAnimationEnd);

    window.setTimeout(() => {
      if (dialog.open) {
        dialog.removeEventListener('animationend', onAnimationEnd);
        finishClose();
      }
    }, 300);
  }

  /**
   * @param {string} drawerId
   */
  static async openById(drawerId) {
    if (!drawerId) return;

    await customElements.whenDefined('whyshift-variant-drawer');

    const drawer = document.getElementById(drawerId);
    if (drawer instanceof WhyshiftVariantDrawer) {
      drawer.open();
    }
  }
}

if (!customElements.get('whyshift-variant-drawer')) {
  customElements.define('whyshift-variant-drawer', WhyshiftVariantDrawer);
}
